import { render, staticRenderFns } from "./HeaderComponent.vue?vue&type=template&id=22a0987a&scoped=true"
import script from "./HeaderComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderComponent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HeaderComponent.vue?vue&type=style&index=0&id=22a0987a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a0987a",
  null
  
)

export default component.exports